<template>
    <div>
        <dx-grid
            url="foodDistributionEnrollmentChanges"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>
        <v-dialog scrollable v-model="updateFamilyDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Address info</v-card-title
                >
                <v-layout column>
                    <div class="mb-3" style="width: 50%">
                        <div>
                            <span class="font-weight-medium pr-2"
                                >Family ID:</span
                            >{{ rowClicked.familyID }}
                        </div>
                        <div>{{ rowClicked.name }}</div>
                    </div>
                    <div
                        class="mb-3 pa-2"
                        style="border: #4caf50 2px solid;"
                        v-if="rowClicked.accountChanges"
                    >
                        <div class="headline">Account Changes</div>
                        <div class="mt-2">
                            <span class="font-weight-medium pr-2 width-200"
                                >Change Type:</span
                            >
                            {{ rowClicked.change }}
                        </div>
                        <div>
                            <span class="font-weight-medium pr-2 width-200"
                                >Current Address:</span
                            >
                            {{ rowClicked.currentAddress }}
                        </div>
                        <div v-if="rowClicked.previousAddress">
                            <span class="font-weight-medium pr-2 width-200"
                                >Previous Address:</span
                            >
                            {{ rowClicked.previousAddress }}
                        </div>
                    </div>
                </v-layout>
                <div>
                    <v-select
                        class="mb-2"
                        hide-details
                        label="Route Number"
                        v-model="rowClicked.currentRoute"
                        :items="routes"
                    ></v-select>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Route Sort"
                        v-model="rowClicked.currentSort"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Label Batch"
                        v-model="rowClicked.currentLabelBatch"
                    ></v-text-field>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateFamilyDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveFamily()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { formatPhoneNumber, toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Enrollment Changes",

        columns: [
            {
                label: "Family ID",
                field: "familyID",
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Change",
                field: "change",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Previous Address",
                field: "previousAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Current Address",
                field: "currentAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Previous Route",
                field: "previousRoute",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Current Route",
                field: "currentRoute",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Previous Sort",
                field: "previousSort",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Current Sort",
                field: "currentSort",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Previous Label Batch",
                field: "previousLabelBatch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Current Label Batch",
                field: "currentLabelBatch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,
        action: "",

        routes: [],
        rowClicked: "",
        updateFamilyDialog: false,

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    async created() {
        this.user = this.$store.state.authentication.user;

        await this.loadRoutes();
    },
    methods: {
        async loadRoutes() {
            const routes = await this.$http.get(
                "api/foodDistributionRoutes/getRouteNames"
            );

            this.routes = routes.filter(Boolean);
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));

            const accountChanges = await this.$http.get(
                "api/FoodDistributionAccountInfo/getAccountChanges?accountID=" +
                    this.rowClicked.familyID
            );

            this.rowClicked.accountChanges = accountChanges;

            this.updateFamilyDialog = true;
        },
        fixPhoneNumber(value) {
            if (!value) return "";

            let number = value.trim().replace(/\D/g, "");

            number = number.length == 10 ? "1" + number : number;

            return number;
        },
        async saveFamily() {
            try {
                await this.$http.post(
                    "api/foodDistributionAccountInfo/updateAddressInfo",
                    {
                        familyID: this.rowClicked.familyID,
                        routeNumber: this.rowClicked.currentRoute,
                        routeSort: this.rowClicked.currentSort,
                        labelBatch: this.rowClicked.currentLabelBatch,
                    }
                );

                this.$notify({
                    group: "notification",
                    text: "Family Saved",
                    type: "success",
                });

                this.updateFamilyDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {}
        },
    },
};
</script>
